import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { accessTokenKey, refreshTokenKey } from '../../../helpers/local-storage';
import { concatPath } from '../../../helpers/path';
import { useLang } from '../../../hooks/use-lang';
import { useQueryParams } from '../../../hooks/use-query-params';
import { AuthPath, ManagerPath, RootPath } from '../../../routes/manager/manager-enums';
import { resetCachedData } from '../../../store/api/utils.ts/cache';
import { useAlertStore } from '../../../store/use-alert-store';
import { useAuthStore } from '../../../store/use-auth-store';
import { useCompanyStore } from '../../../store/use-company-store';
import { useManagerStore } from '../../../store/use-manager-store';

export const useHeader = () => {
  const { saveManagerProfile, isLoadingFetch, fetchManagerProfile, managerProfile } =
    useManagerStore();
  const { fetchCompanyProfile, companyProfile } = useCompanyStore();
  const { reset } = useAlertStore();
  const { logout } = useAuthStore();
  const { addQueryParams } = useQueryParams();

  const { t } = useLang();

  useEffect(() => {
    fetchCompanyProfile();
    fetchManagerProfile();
  }, []);

  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem(accessTokenKey);
    localStorage.removeItem(refreshTokenKey);

    if ('serviceWorker' in navigator) {
      const isExist = await navigator.serviceWorker.getRegistrations();
      if (isExist) {
        isExist.forEach(async (sw) => sw.unregister());
      }
    }
    await logout();
    reset();
    resetCachedData();
    navigate(concatPath([RootPath.Manager, ManagerPath.Auth, AuthPath.Login]));
    window.location.reload();
  };

  const name = `${saveManagerProfile?.first_name || ''} ${saveManagerProfile?.last_name} `;

  return {
    name,
    companyName: companyProfile?.name,
    handleLogout,
    isLoadingFetch,
    role: managerProfile?.role,
    t,
    addQueryParams,
  };
};
